export default __webpack_public_path__ + "static/media/Group8393.34f5f74f.svg";